/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_PaidInputs */

const en_admin_payments_status_paid = /** @type {(inputs: Admin_Payments_Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Admin_Payments_Status_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_paid = /** @type {((inputs?: Admin_Payments_Status_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_status_paid(inputs)
});
export { admin_payments_status_paid as "admin.payments.status_paid" }